// Zengin metin editörünün renk paletleri. Değerler bilerek düz hex: API'deki
// sanitize-html yalnızca hex/rgb/hsl/adlandırılmış renkleri kabul eder, CSS
// değişkenleri (var(--primary)) kayıtta silinirdi.

export interface EditorColor {
  label: string;
  value: string;
}

// Yazı rengi: sitenin marka renkleri (web globals.css :root) + temel renkler.
export const TEXT_COLORS: EditorColor[] = [
  { label: "Lacivert (marka)", value: "#0f2b46" },
  { label: "Kırmızı (marka)", value: "#c3022d" },
  { label: "Siyah", value: "#000000" },
  { label: "Koyu gri", value: "#374151" },
  { label: "Gri", value: "#6b7280" },
  { label: "Kırmızı", value: "#dc2626" },
  { label: "Turuncu", value: "#ea580c" },
  { label: "Yeşil", value: "#16a34a" },
  { label: "Mavi", value: "#2563eb" },
  { label: "Mor", value: "#7c3aed" },
];

// Vurgu (arka plan) rengi: okunabilir kalsın diye açık tonlar.
export const HIGHLIGHT_COLORS: EditorColor[] = [
  { label: "Sarı", value: "#fef08a" },
  { label: "Yeşil", value: "#bbf7d0" },
  { label: "Mavi", value: "#bfdbfe" },
  { label: "Açık lacivert (marka)", value: "#dbe4ee" },
  { label: "Pembe (marka)", value: "#fde2e7" },
  { label: "Turuncu", value: "#fed7aa" },
  { label: "Mor", value: "#e9d5ff" },
  { label: "Gri", value: "#e5e7eb" },
];
